export const windowEventListenerCreator = (name, callBack) => {
  window.addEventListener(name, callBack);
};

export const windowEventListenerRemover = (name, callBack) => {
  window.removeEventListener(name, callBack);
};
